/**
 * Cardiology Medicine Consultations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import AppConfig from "../../../constants/AppConfig";
import {store} from "../../store";

// States
const state = {
    cardiologyConsultations: [],
    cardiologyConsultation: {}
};

// Getters
const getters = {
    cardiologyConsultations: state => {
        return state.cardiologyConsultations
    },

    cardiologyConsultation: state => {
        return state.cardiologyConsultation
    }
};

// Actions
const actions = {
    printConsultationCardiologie(context, payload) {
        function successCallback(response) {
            let url= AppConfig.imgUrl+'/public/storage/pdf/'+response.data.name;
            let fileName = response.data.name;

            Vue.axios.get(
                url,{
                    responseType: 'blob', // important
                }
            ).then((response) => {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        }


        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Cardiology.Print, localToken, successCallback, errorCallback, payload.errorMessages);
    },


    getCardiologyConsultations(context, payload) {
        function successCallback(response) {
            context.commit('getCardiologyConsultationsHandler', { consultations: response.data.consultations });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Cardiology.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getCardiologyConsultation(context, payload) {
        function successCallback(response) {
            context.commit('getCardiologyConsultationHandler', { consultation: response.data.consultation });
            context.commit('getMedicalFileHandler', { file: response.data.consultation.dossier });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Cardiology.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createCardiologyConsultation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );


            //Push to list of consultation
            // router.push({ name: 'consultations-cardiologys' });

            //Push to created consultation
            router.push({ name: 'consultation-cardiology', params: { consultation: response.data.consultation.slug } });


        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');
        let url = AppConfig.apiUrl + apiModel.Consultation.Cardiology.Create.url;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
        // makeApiRequest(payload.args, apiModel.Consultation.Cardiology.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateCardiologyConsultation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            //Push to list of consultation
            // router.push({ name: 'consultations-cardiologys' });

            //Push to edited consultation
            store.dispatch('findAndRemove', {name: 'consultation-cardiology' });

            router.push({ name: 'consultation-cardiology', params: { consultation: response.data.consultation.slug } });
        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        let url = AppConfig.apiUrl + apiModel.Consultation.Cardiology.Create.url + '/' + payload.consultation;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);

        // makeApiRequest(payload.args, apiModel.Consultation.Cardiology.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteCardiologyConsultation(context, payload) {
        function successCallback(response) {
            // context.commit('deleteCardiologyConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.consultation.dossier.slug } }).href) +"#cardiologie");
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Cardiology.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    archieveCardiologyConsultation(context, payload) {
        function successCallback(response) {
            context.commit('archieveCardiologyConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getCardiologyConsultationHandler', { consultation: response.data.resultat });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Cardiology.Archieve, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    transmitCardiologyConsultation(context, payload) {
        function successCallback(response) {
            context.commit('transmitCardiologyConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getCardiologyConsultationHandler', { consultation: response.data.resultat });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Cardiology.Transmit, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    reactiveCardiologyConsultation(context, payload) {
        function successCallback(response) {
            context.commit('reactiveCardiologyConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getCardiologyConsultationHandler', { consultation: response.data.resultat });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Cardiology.Reactive, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    setAllergieHandler(state,{allergies}){
        if (state.cardiologyConsultation.hasOwnProperty('dossier')){
            let dossier = state.cardiologyConsultation.dossier;
            if (dossier.hasOwnProperty('allergies')){
                state.cardiologyConsultation.dossier.allergies = allergies;
            }
        }
    },

    setAntecedentHandler(state,{antecedents}){
        if (state.cardiologyConsultation.hasOwnProperty('dossier')){
            let dossier = state.cardiologyConsultation.dossier;
            if (dossier.hasOwnProperty('antecedents')){
                state.cardiologyConsultation.dossier.antecedents = antecedents;
            }
        }
    },

    getCardiologyConsultationsHandler(state, { consultations }) {
        // Update cardiologyConsultations state
        state.cardiologyConsultations = consultations;
    },

    getCardiologyConsultationHandler(state, { consultation }) {
        // Update cardiologyConsultation state
        state.cardiologyConsultation = consultation;
    },

    updateCardiologyCardiologyFileHandler(state,{files}){
        state.cardiologyConsultation.files = files
    },

    deleteCardiologyConsultationHandler(state, { index, successMessage }) {
        // let i = state.cardiologyConsultations.findIndex(consultation => consultation.slug === index);
        //
        // if (~i) {
        //     state.cardiologyConsultations.splice(i, 1);

        // router.push({ name: 'consultations-cardiologys' });


        Vue.swal(
            payload.successMessage,
            '',
            'success'
        );
        // }
    },

    deleteConsultationPhysicalExamHandler(state, { index, successMessage }) {
        let i = state.physicalExams.findIndex(physicalExam => physicalExam.slug === index);

        if (~i) {
            state.physicalExams.splice(i, 1);

            router.push({ name: 'consultation-physical-exams' });

            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }
    },

    deleteConsultationComplementaryExamHandler(state, { index, successMessage }) {
        let i = state.complementaryExams.findIndex(complementaryExam => complementaryExam.slug === index);

        if (~i) {
            state.complementaryExams.splice(i, 1);

            router.push({ name: 'consultation-complementary-exams' });

            Vue.swal(
                successMessage,
                '',
                'error'
            );
        }
    },

    archieveCardiologyConsultationHandler(state, { index, successMessage }) {
        // router.push({ name: 'consultations-cardiologys' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    reactiveCardiologyConsultationHandler(state, { index, successMessage }) {
        // router.push({ name: 'consultations-cardiologys' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    transmitCardiologyConsultationHandler(state, { index, successMessage }) {
        // router.push({ name: 'consultations-cardiologys' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}